/**
 * Threshold indicating low quota.
 *
 * This is a value between 0 and 1.
 */
export const LOW_QUOTA_THRESHOLD = 0.1;

/**
 * HTTP status code for Too Many Requests.
 */
export const STATUS_TOO_MANY_REQUESTS = 429;

/**
 * HTTP status code for Forbidden.
 */
export const STATUS_FORBIDDEN = 403;

/**
 * HTTP status code for Bad Request.
 */
export const STATUS_BAD_REQUEST = 400;

/**
 * Error code for quota exceeded.
 */
export const ERROR_CODE_QUOTA_EXCEEDED = "quota_exceeded";

/**
 * Error code for rate limited.
 */
export const ERROR_CODE_RATE_LIMITED = "rate_limited";

/**
 * Error code for invalid input.
 */
export const ERROR_CODE_INVALID_INPUT = "invalid_input";
